import React from 'react'
import { useSelector } from 'react-redux'
import Select from 'antd/lib/select'
import { setCurrentBuilding } from '../../../lib/setCurrentBuilding'

const { Option } = Select

const styles = {
    container: {
        float: 'left',
        zIndex: 10
    },
    select: {
        marginLeft: 10,
        width: 280,
    },
    text: {
        marginLeft: '0.64em',
        color: '#fff',
    },
}

function BuildingSelector() {
    const buildingName = useSelector((state) => state.app.building.name)
    const tenantName = useSelector((state => state.app.tenant.name))
    const occupancies = useSelector((state) => state.app.occupancies)
    const defaultIndex = occupancies.findIndex((item) => item.building === buildingName && item.tenant === tenantName)

    if (occupancies.length < 2) return null


    const generateName = (item) => {
        // if(item.building === item.property) {
        return `${item.building} - ${item.tenant}`
        // } else {
        //     return `${item.property} - ${item.tenant}`
        // }
    }

    const handleBuildingChange = (index) => {
        // Add a flag to indicate this change comes from the building selector
        const buildingData = {
            ...occupancies[index],
            __fromBuildingSelector: true
        };
        setCurrentBuilding(buildingData);
    };

    return (
        <div style={styles.container}>
            <span style={styles.text}>Select Building: </span>
            <Select
                value={defaultIndex === -1 ? undefined : defaultIndex}
                style={styles.select}
                onChange={handleBuildingChange}
            >
                {occupancies.map((item, index) => (
                    <Option key={item.pk} value={index}>
                        {generateName(item)}
                    </Option>
                ))}
            </Select>
        </div>
    )
}

export default BuildingSelector
